import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { ProjectObject } from 'src/app/core/models/hvac-modes/project-object.model';
import { ProjectSubObject } from 'src/app/core/models/hvac-modes/project-sub-object.model';
import { LocationGroup } from '../services/api-location-groups.service';

@Pipe({
  name: 'getFloorsForEditingGroups',
})
export class GetFloorsForEditingGroupsPipe implements PipeTransform {
  transform(allFloors: LocationGroup[], controllers: Controller[],
  targetObject: ProjectObject, targetSubobject: ProjectSubObject): LocationGroup[] {
      const targetObj: string = targetObject.designation.split('/')[0];
      const targetSubobj: string = targetSubobject.designation.split('/')[1];

      const floorsInObjectAndSuboject = allFloors.filter((flo)=> {
        return flo.locationIds.some((locId: string)=> {
          const floorObject = locId.split('/')[0];
          const floorSubobject = locId.split('/')[1];
          return targetObj === floorObject && targetSubobj === floorSubobject
        })
      })

      //
      /* fList = fList.filter((f)=> {
        const floorListObject = f.locationIds[0].split('/')[0];
        const floorListSubObject = f.locationIds[0].split('/')[1];
        const targetObj: string = targetObject.designation.split('/')[0];
        const targetSubobj: string = targetObject.designation.split('/')[1];
        return Number(floorListObject) === Number(targetObj) && Number(floorListSubObject) === Number(targetSubobj)
      }).slice();
      console.log(fList) */


        const floorList = floorsInObjectAndSuboject.slice();
        const controllersOnFloors:string[]  = floorList.reduce((flList,floor)=> {
            flList = [...floor.locationIds, ...flList]
            return flList;
          },[])
        const floorForUndistributedControllers: LocationGroup = {
            id: 9999,
            name: 'Undistributed',
            locationGroupTypeId: 3,
            locationIds: []
          };

          controllers.forEach((cont : Controller)=> {
            // const controllerObj: string = cont.designation.split('/')[0];
            // const controllerSubobj: string = cont.designation.split('/')[1];
            if (cont.object === targetObj && cont.subObject === targetSubobj && !controllersOnFloors.includes(cont.designation)) {
              floorForUndistributedControllers.locationIds.push(cont.designation);
            }
          })



          if (floorForUndistributedControllers.locationIds.length>0) {
            floorList.push(floorForUndistributedControllers)
          }
          return floorList;

    /* let floorsForSubobject;
    if (Number(targetObject) < 0 && Number(targetSubobject) < 0) {
      floorsForSubobject = allFloors;
    }
    else if ( Number(targetSubobject) < 0) {
      floorsForSubobject = allFloors.filter((fl)=> {
        return fl.locationIds.every((locationId)=> {
          const obj = locationId.split('/')[0];
          return Number(obj) === Number(targetObject)
        })
      })
    } else {
      floorsForSubobject = allFloors.filter((f) => {
        const floorListObject = f.locationIds[0].split('/')[0];
        const floorListSubObject = f.locationIds[0].split('/')[1];
        return (
          Number(floorListObject) === Number(targetObject) && Number(floorListSubObject) === Number(targetSubobject)
        );
      })
      .slice();
    } */
   /*  if (!floorsForSubobject || floorsForSubobject.length === 0) {
      // no floorlist, generates floor list
      return Project.getGeneratedFloors(
        project,
        targetObject,
        targetSubobject
      ).slice();
    } else { */
     /*  const floorList = floorsForSubobject.slice();
      const controllersOnFloors: string[] = floorList.reduce(
        (flList, floor) => {
          flList = [...floor.locationIds, ...flList];
          return flList;
        },
        []
      );
      const floorForUndistributedControllers: LocationGroup = {
        id: 99999,
        name: 'Undistributed',
        locationGroupTypeId: 3,
        locationIds: [],
      };

      project.controllers.forEach((driver) => {
        driver[1].forEach((object) => {
          if (Number(object[0]) === Number(targetObject) || Number(targetObject) < 0 ) {
            object[1].forEach((subObj) => {
              if (Number(subObj[0]) === Number(targetSubobject) || Number(targetSubobject) < 0) {
                subObj[1].forEach((zone) => {
                  zone[1].forEach((subZone) => {
                    if (!controllersOnFloors.includes(subZone[1].locationId)) {
                      floorForUndistributedControllers.locationIds.push(
                        subZone[1].locationId
                      );
                    }
                  });
                });
              }
            });
          }
        });
      });
      if (floorForUndistributedControllers.locationIds.length > 0) {
        floorList.push(floorForUndistributedControllers);
      }
      return floorList; */
   /*  } */
  }
}
